import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import PageBody from 'components/atoms/PageBody'
import PageHeading from 'components/atoms/PageHeading'
import LessonPlanForm from 'components/organisms/forms/LessonPlanForm'

import { crudActionsMap } from 'utils/helpers'

const LessonPlanCrudPage = () => {
  const { t } = useTranslation()
  const params = useParams()
  const id = params?.id

  const action = crudActionsMap[params['*']?.split('/')?.[1]]
  const viewOnly = action === 'view' || action === 'delete'

  return (
    <>
      <PageHeading title={`${t('common.lesson-plans')} / ${t('common.' + action)}`} />
      <PageBody>
        <LessonPlanForm action={action} id={id} viewOnly={viewOnly} />
      </PageBody>
    </>
  )
}
export default LessonPlanCrudPage
